import { render, staticRenderFns } from "./Desktop.vue?vue&type=template&id=be906270&"
import script from "./Desktop.vue?vue&type=script&lang=js&"
export * from "./Desktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports